import type { ReactElement } from "react";

import type { TaskResponse } from "../features/queue/api";
import { useCancelTask } from "../features/queue/useCancelTask";
import { TaskActionButton } from "./TaskActionButton";
import type { TaskActionKeys } from "./TaskActionButton";

// Кнопка «Отменить задачу». Используется в баннере escalated, баннере
// awaiting_plan_approval и в секции «Действия» страницы задачи.
// Поведение (409, ошибки, блокировка закрытия окна) — в TaskActionButton.
const KEYS: TaskActionKeys = {
  button: "task.cancelButton",
  inFlight: "task.cancelInFlight",
  confirmTitle: "task.cancelConfirmTitle",
  confirmBody: "task.cancelConfirmBody",
  confirmAccept: "task.cancelConfirmAccept",
  confirmReject: "task.cancelConfirmReject",
  errorTitle: "task.cancelErrorTitle",
};

export function CancelTaskButton({
  task,
}: {
  readonly task: TaskResponse;
}): ReactElement {
  const mutation = useCancelTask(task.id);
  return <TaskActionButton mutation={mutation} keys={KEYS} color="red" />;
}
